export const CHAT_ACTIONS = [
    { name: 'Invite Team Member', text: 'Invite a new user into the system.', enum: 'onboarding' },
    // { name: 'Manage Notification Permissions', text: 'Control who receives alerts and updates.', enum: 'manage-notifications' },
    { name: 'Add Competitor', text: 'Add competitor.', enum: 'addCompetitor' },
    { name: 'Edit Competitor Sets', text: 'Update competitor.', enum: 'editCompetitor' },
    { name: 'Add Prompt', text: 'Add prompt.', enum: 'addPrompt' },
    { name: 'Edit Prompts', text: 'Update prompt.', enum: 'editPrompt' },
    // { name: 'Change user access', text: 'Change user access.', enum: 'changeAccess' },
    // { name: 'Set up account', text: 'Create user account.', enum: 'setUpAccount' },
]

export const CHAT_ACTIONS_ADMIN = [
    { name: 'Invite Team Member', text: 'Invite a new user into the system.', enum: 'onboarding' },
    // { name: 'Manage Notification Permissions', text: 'Control who receives alerts and updates.', enum: 'manage-notifications' },
    { name: 'Add Competitor', text: 'Add competitor.', enum: 'addCompetitor' },
    { name: 'Edit Competitor Sets', text: 'Update competitor.', enum: 'editCompetitor' },
    { name: 'Add Prompt', text: 'Add prompt.', enum: 'addPrompt' },
    { name: 'Edit Prompts', text: 'Update prompt.', enum: 'editPrompt' },
    // { name: 'Change user access', text: 'Change user access.', enum: 'changeAccess' },
    // { name: 'Set up account', text: 'Create user account.', enum: 'setUpAccount' },
]